import gql from 'graphql-tag'

import { ChildFieldsFragment } from 'main/gql/child'
import { DesiredWeeklyScheduleFieldsFragment } from 'main/gql/desiredWeeklySchedule'
import {
  SchoolFieldsFragment,
  SchoolWithDirectorFieldsFragment,
  SchoolWithProfileFieldsFragment,
} from 'main/gql/school'
import { TourFieldsFragment, TourOpeningFieldsFragment } from 'main/gql/tour'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

// HACK (alex): School ID is passed as both an Int! and an ID!, as the school and tour queries use
// different types and Apollo type generation was failing due to type mismatches.
export const SCHEDULE_TOUR_MODAL_QUERY = gql`
  query ScheduleTourModal($schoolId: ID!, $schoolIdInt: Int!, $beginsOn: Date!, $endsOn: Date!) {
    desiredWeeklySchedule {
      ...DesiredWeeklyScheduleFields
    }
    school(id: $schoolIdInt) {
      ...SchoolFields
      ...SchoolWithDirectorFields
      ...SchoolWithProfileFields
    }
    upcomingTours: tours(schoolId: $schoolId, onlyUpcoming: true) {
      ...TourFields
      children {
        ...ChildFields
      }
    }
    tourOpenings(schoolId: $schoolId, beginsOn: $beginsOn, endsOn: $endsOn, onlySchedulable: true) {
      ...TourOpeningFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${ChildFieldsFragment}
  ${DesiredWeeklyScheduleFieldsFragment}
  ${SchoolFieldsFragment}
  ${SchoolWithDirectorFieldsFragment}
  ${SchoolWithProfileFieldsFragment}
  ${TourFieldsFragment}
  ${TourOpeningFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
